import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link, replace } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MapsUgcOutlinedIcon from '@mui/icons-material/MapsUgcOutlined';
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ConstructionIcon from '@mui/icons-material/Construction';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const GyaaniSidenav = () => {
  const loginName = localStorage.getItem("loginName");
  const clientCode = localStorage.getItem("clientCode");
  const [role, setRole] = useState(null);



  const [hasGyanni, setHasGyanni] = useState(false);

  let updatedLoginName = "";

  if (loginName) {
    updatedLoginName = loginName.replace(/_/g, " ");
  }

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    const storedRole = localStorage.getItem("role");

    if (storedRole) {
      setRole(storedRole);
    } else {
      console.warn("No role found in localStorage");
    }
  }, []);


  

  useEffect(() => {
    const activeModulesRaw = localStorage.getItem("ActiveModules");
    const activeModules = activeModulesRaw ? JSON.parse(activeModulesRaw) : [];
    setHasGyanni(activeModules.includes("gyaani"));
  }, []);

  useEffect(() => {
    console.log("hasGyanni state updated:", hasGyanni);
  }, [hasGyanni]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selected, setSelected] = useState("Dashboard");

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h6" color={colors.grey[100]}>
                  GYAANi Module
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="Global profile-user"
                  className="w-[80px] rounded-full bg-white p-2"
                  src={`https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/freepik__background__20610.png?updatedAt=1747297047839`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h4"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                  className="capitalize"
                >
                  {updatedLoginName}
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  <h6 className="mt-2 uppercase font-bold">{clientCode}</h6>
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            {role === "Admin" ? (
              <>
                <Item
                  title="Dashboard"
                  to="/GYAANi"
                  icon={<HomeOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  
                </Typography>

                <Item
                  title="Create User"
                  to="/GYAANi/users"
                  icon={<ReceiptOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Create Role"
                  to="/GYAANi/MSTRole"
                  icon={<PersonOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Role User Mapping"
                  to="/GYAANi/UserRoleAction"
                  icon={<MapsUgcOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </>
            ) : role === "Super Admin" || role === "SuperAdmin" ? (
              <>
                <Item
                  title="Dashboard"
                  to="/GYAANi"
                  icon={<HomeOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  
                </Typography>
                <Item
                  title="Create Client"
                  to="/GYAANi/clients"
                  icon={<PeopleOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Create Organization"
                  to="/GYAANi/organization"
                  icon={<ContactsOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Create User"
                  to="/GYAANi/users"
                  icon={<ReceiptOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Create Role"
                  to="/GYAANi/MSTRole"
                  icon={<PersonOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  
                </Typography>
                <Item
                  title="Create Module"
                  to="/GYAANi/MstModule"
                  icon={<CalendarTodayOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  
                </Typography>
                <Item
                  title="Role User Mapping"
                  to="/GYAANi/UserRoleAction"
                  icon={<MapsUgcOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  title="Module Role Mapping"
                  to="/GYAANi/MapModuleRoleUserAction"
                  icon={<MapsUgcOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  
                </Typography>
                <Item
                  title="LLM Model Configuration"
                  to="/GYAANi/LlmModelConfiguration"
                  icon={<ConstructionIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  
                </Typography>
                <Item
                  title="Bulk User Upload"
                  to="/GYAANi/BulkUserUpload"
                  icon={<SupervisedUserCircleOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />

                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
     
                </Typography>
                <Item
                  title="Partner's List"
                  to="/Partners"
                  icon={<GroupWorkIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </>
            ) : null}
          </Box>

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            {role === "Admin" || role === "admin" && hasGyanni ? (
              <>
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 20px" }}
                >
                  File Upload's Data
                </Typography>
                <Item
                  title="File Upload"
                  to="/solution-GPT/fileupload"
                  icon={<BarChartOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </>
            ) : null}
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default GyaaniSidenav;
